import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import LandingPage from "../pages/LandingPage/LandingPage";
import AboutPage from "@/pages/AboutPage/AboutPage";
import ProductPage from "@/pages/ProductPage/ProductPage";
import ServicePage from "@/pages/ServicePage/ServicePage";
import NewsPage from "@/pages/NewsPage/NewsPage";
import ContactPage from "@/pages/ContactPage/ContactPage";
import GetStartedPage from "@/pages/GetStartedPage/GetStartedPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage/ServiceDetailPage";
import ProductDetailPage from "@/pages/ProductDetailPage/ProductDetailPage";

// Not prerendered (login + API-driven article pages): loaded on demand.
const LoginPage = React.lazy(() => import("../pages/LoginPage/LoginPage"));
const ArticleDetailPage = React.lazy(() =>
  import("@/components/Article/ArticleDetailPage/ArticleDetailPage")
);

/** Decide auth either from parent prop or from a token fallback */
const isAuthed = (user) =>
  !!user || typeof window !== "undefined"
    ? !!localStorage.getItem("auth_token")
    : false;

const GuestRoutes = ({ history, user }) => {
  return (
    <Switch>
      {/* Locale-aware routes */}
      <Route
        path="/:lang/login"
        render={(routeProps) => <LoginPage {...routeProps} />}
      />

      {/* moved article and category routes to user routes */}
      <Route
        exact
        path="/:lang/about"
        render={(routeProps) => <AboutPage {...routeProps} />}
      />

      <Route
        path="/:lang/product/:productName"
        render={(routeProps) => <ProductDetailPage {...routeProps} />}
      />
      <Route
        exact
        path="/:lang/product"
        render={(routeProps) => <ProductPage {...routeProps} />}
      />

      <Route
        exact
        path="/:lang/our-service"
        render={(routeProps) => <ServicePage {...routeProps} />}
      />

      {/* ---------- Conditional redirects for logged-in users ---------- */}
      {/* Public article detail → user article detail */}
      <Route
        path="/:lang/article/:id"
        render={(routeProps) => {
          const { match } = routeProps;
          if (isAuthed(user)) {
            return (
              <Redirect
                to={`/${match.params.lang}/user/article/${match.params.id}`}
              />
            );
          }
          return <ArticleDetailPage {...routeProps} />;
        }}
      />

      {/* Public blogs detail → user blogs detail (optional but consistent) */}
      <Route
        path="/:lang/blogs/:id"
        render={(routeProps) => {
          const { match } = routeProps;
          if (isAuthed(user)) {
            return (
              <Redirect
                to={`/${match.params.lang}/user/blogs/${match.params.id}`}
              />
            );
          }
          return <ArticleDetailPage {...routeProps} />;
        }}
      />

      {/* Public blogs list → user blogs list */}
      <Route
        exact
        path="/:lang/blogs"
        render={(routeProps) => {
          const { match } = routeProps;
          if (isAuthed(user)) {
            return <Redirect to={`/${match.params.lang}/user/blogs`} />;
          }
          return <NewsPage {...routeProps} />;
        }}
      />
      {/* ---------- end conditional redirects ---------- */}

      <Route
        exact
        path="/:lang/contact-us"
        render={(routeProps) => <ContactPage {...routeProps} />}
      />
      <Route
        exact
        path="/:lang/get-started"
        render={(routeProps) => <GetStartedPage {...routeProps} />}
      />

      <Route
        path="/:lang/service/:serviceName"
        render={(routeProps) => <ServiceDetailPage {...routeProps} />}
      />

      {/* Home for each locale (keep last) */}
      <Route
        path="/:lang"
        render={(routeProps) => <LandingPage {...routeProps} />}
      />
    </Switch>
  );
};

GuestRoutes.propTypes = {};

export default GuestRoutes;
